<template>
  <div class="container" v-if="loadingPageOver" :style="iosOrAndroidStyle">
    <w-nav-bar
      :icon="'iconchevron-left'"
      nav_title="我的订单"
      @mobileLeftBtn="leftBtnClick"
      v-show="iosOrAndroidShow"
    />
    <div v-if="loadPageDataFinished">
      <div class="order-container" :class="{'mobile-page-container': !isIos}">
        <div v-if="ordersData.length > 0">
          <div class="table-div">
            <table class="table">
              <tbody>
              <tr>
                <th>订单类型</th>
                <th>下单时间</th>
                <th>状态</th>
              </tr>
              <tr v-for="order in ordersData" :key="order.id">
                <td>{{order.order.display_plan}}</td>
                <td>{{order.order.created_at | timeFormatFilter}}</td>
                <td v-if="order.order.aasm_state === 'paid'" class="flex-column-center">
                  {{ order.order.display_state }}

<!--                  <a v-if="order.order.plan === 'calendar' || order.order.plan === 'calendar_groupon'" class="order-query-btn"-->
<!--                     @click="goBuySuccess(order.order.token)">-->
<!--                    {{ order.order.order_status_query_btn_text }}-->
<!--                  </a>-->
<!--&lt;!&ndash;                  <a v-if="order.model_name === 'MentorOrder' && order.cv_not_selected" @click="toImproveInfo(order)">去完善</a>&ndash;&gt;-->
<!--                  <a v-if="order.order.order_status_query_btn_text === '状态查询'" class="order-query-btn"-->
<!--                     @click="queryOrder(order.order.token)">{{ order.order.order_status_query_btn_text }}</a>-->
                </td>

                <td v-else-if="order.order.aasm_state === 'invalid_order'">
                  {{ order.order.display_state }}
                </td>

                <td v-else-if="order.order.aasm_state === 'refund'">
                  {{ order.order.display_state }}
                </td>

                <td v-else class="flex-column-center">
                  <div @click="toPay(order.order)">{{ order.order.display_state }}</div>
                  <a class="cancel-btn" @click="cancelOrder(order.order)">取消订单</a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-else class='no-order-div'>
          <img class="no-order-image" src="https://files.wondercv.com/no_order.png"/>
        </div>
      </div>
      <pay-dialog :state="dialogShow" :descriptionInfo="descriptionInfo" :imgSrc="imgSrc" :dialog-type="dialogType"
                  @shareWx="sendWechat"
                  @handleClose="dialogShow = false"></pay-dialog>
      <!--      <member-pay-dialog :state="dialogShow" @sendWechat="sendWechat"-->
      <!--                         @handleClose="dialogShow = false"></member-pay-dialog>-->
    </div>
  </div>
</template>

<script>
  import WNavBar from "@/components/global/w-navbar";
  import memberPayDialog from '@/components/ios/member-pay-dialog'
  import payDialog from '@/components/ios/pay-dialog'
import { setupWebViewJavascriptBridge } from '@/assets/js/utils'
import { componentsMixin } from '../../assets/js/mixin/components'
import { envMixin, loginMixin } from '@/assets/js/mixin/global'
import Cookies from "js-cookie";

  export default {
    mixins: [ envMixin, loginMixin, componentsMixin ],
    head () {
        return {
            title: '我的订单'
        }
    },
    data () {
        return {
            _t: '',
            goBackIcon: 'iconchevron-left',
            userSignedIn: false,
            ordersData: '',
            dialogShow: false,
            loadPageDataFinished: false, // 数据加载完成 显示页面
            descriptionInfo: [], // 弹窗的文案
            imgSrc: '', // 弹窗顶部图片的url
            dialogType: ''
        }
    },
    components: {
        WNavBar,
        payDialog,
        memberPayDialog
    },
    mounted () {
      let _t = Cookies.get("_t");
      this._t = _t;
      this.loadPageData()
    },
    watch: {},
    computed: {},
    methods: {
      leftBtnClick() {
        if (window.history.length > 1) {
          window.history.back()
        } else {
          this.routeTo('/account/users/index')
        }
      },
      async loadPageData () {
        if (this._t) {
          this.userSignedIn = true
          let tokenPayload = JSON.parse(window.atob(this._t.split(".")[1]));
          this.$api.user.getAccountOrders(tokenPayload.User.c_t)
            .then((response) => {
              console.log(response)
              if (response.code === 1000) {
                this.ordersData = response.data.orders
                this.loadPageDataFinished = true
              }
            })
            .catch(() => {
              this.showToast({
                message: '请求失败，请重试',
                duration: 1000
              })
            })
        }
      },
      async queryOrder (orderToken) {
        let userInfo = await this.getUserInfo()
        let params = {
          public_key: userInfo.publicKey,
          nonce: new Date().getTime(),
          token: orderToken
        }
        let signature = this.$getSignature(params, userInfo.privateKey)
        params.signature = signature
        this.$api.me.queryOrder(this, params)
          .then((response) => {
            if (response.status === 1) {
                window.location.reload()
            }
          }).catch(() => {
            this.showToast({
              message: '请求失败，请重试',
              duration: 1000
            })
          })
      },
      async cancelOrder (order) {
        let type = ""
        if(order.model_name == "ImprovedOrders"){
          type = "improved_order"
        }else if(order.model_name == "MentorOrders"){
          type = "mentor_order"
        }
        let tokenPayload = JSON.parse(window.atob(this._t.split(".")[1]));
        let params = {
          public_key: '',
          nonce: new Date().getTime(),
          order_token: order.token,
          cv_account_token: tokenPayload.User.c_t,
          type: type
        }

        this.$api.user.cancelOrder(params)
          .then((response) => {
            if (response.code === 1000) {
              this.showToast({ message: '订单取消成功', duration: 1000 })
              window.location.reload()
            }
          }).catch(() => {
            this.showToast({
              message: '请求失败，请重试',
              duration: 1000
            })
          })
      },
      goBuySuccess (orderToken) {
        window.location.href = `/activity/groupon_calendar/buy_success?order_token=${ orderToken }`
      },
      returnFunction () {
        window.location.href = '/account/users/mobile_account_index'
      },
      sendWechat () {
        if (this.iosOrAndroid) {
          setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('shareMyOrder', {
              title: '超级简历 | 支付我的订单',
              desc: 'HR 推荐的专业简历，手机电脑同步编辑，中英双语模板，名企精英都在用。'
            }, function responseCallback (responseData) {
            })
          })
        }
      },
      toPay (order) {
        if (this.isIos) {
          // 判断是超级会员未支付订单还是导师辅导未支付订单
          if (order.model_name === 'MentorOrder') {
            this.descriptionInfo = [
              '来自顶级名企的专业导师',
              '投行咨询、BAT大厂、五百强',
              '中英文简历 1 对 1 反馈辅导',
              '帮你大幅提升求职成功率'
            ]
            this.imgSrc = 'https://files.wondercv.com/mobile/orders/ios-dialog.png'
            this.dialogType = 'member'
          } else if (order.model_name === 'ImprovedOrder') {
            this.imgSrc = 'https://files.wondercv.com/mobile/cvs/ios-pay-member.png'
            this.descriptionInfo = [
              '享受超级简历所有特权',
              'AI 简历助手 智能改简历',
              '无限使用大牛模板案例',
              '帮你大幅提升求职成功率'
            ]
            this.dialogType = 'member'
          }
          this.dialogShow = true
        } else {
          this.showToast('请去pc进行支付')
        }
      }
    }
  }
</script>
<style scoped lang="scss" rel="stylesheet/scss">
  .order-query-btn {
    color: #9c9c9c;
    border: 1px solid #dedfe1;
    padding: 0 3px;
    font-size: 13px;
  }
  .container {
    height: 100%;
    padding-top: 44px;
    .order-container {
      left: 0;
      right: 0;
      background: #f5f5f7;
      height: 100%;
    }
    .no-order-div {
      height: 100%;
      width: 100%;
      background-color: #fff;
      .no-order-image {
        width: 100%;
        margin-top: 70px;
      }
    }
    .table-div {
      padding-top: 10px;
      .table {
        /* min-height: 155px; */
        background-color: #fff;
        width: 100%;
        border-left: 16px solid #fff;
        border-right: 16px solid #fff;
        th {
          font-size: 14px;
          color: #404040;
          padding-top: 10px;
          padding-bottom: 5px;
          font-weight: bold;
        }
        tr {
          border-bottom: 1px solid #dedfe1;
          vertical-align: middle;
          text-align: center;
        }
        td {
          font-size: 14px;
          color: #666666;
          height: 36px;
          vertical-align: middle;
          a, div {
            color: #50a4ff;
          }
          .cancel-btn {
            color: #9c9c9c;
            border: 1px solid #dedfe1;
            padding: 0 3px;
            font-size: 13px;
            margin-top: 3px;
          }
        }
      }
    }
  }
</style>
